import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const cartSlice = createSlice({
  name: 'cart',
  initialState: {},
  reducers: {
    cartReducer: {
      reducer: (state, action) => (state = action.payload),
      prepare: (value) => ({ payload: value || [] }),
    },
  },
});

export const cart = (state) => state.cart;

export const { cartReducer } = cartSlice.actions;
export default cartSlice.reducer;